import type {
  FarePriceBreakdown,
  Prices,
  PassengerPricing,
} from "@b2bportal/air-shopping-api";
import { Funnel } from "@b2bportal/core-types";
import { useGetCurrentFunnel } from "../hooks/useGetCurrentFunnel";

export const useGetFixedPricingFromFare = () => {
  const currFunnel = useGetCurrentFunnel();
  const isInPackagesFlow = currFunnel === Funnel.Package;

  return (passengerPricing: PassengerPricing): Prices | FarePriceBreakdown => {
    const paxPricing = passengerPricing.pricing;
    const totalPricing = passengerPricing.pricing.total;

    // For packages, return totalPricing directly (already flattened by usePackageFlightFaresSource)
    if (isInPackagesFlow) {
      return totalPricing;
    }

    if (totalPricing.fiat.value > 0) {
      return totalPricing;
    }

    // If total pricing is 0, it is a fixed price fare made up of taxes and fees and base amount (in points)
    return {
      taxesAndFees: paxPricing.taxAmount,
      baseAmount: paxPricing.baseAmount,
      taxLineItems: paxPricing.taxLineItems,
    };
  };
};

// Legacy export for backwards compatibility
export const getFixedPricingFromFare = (
  passengerPricing: PassengerPricing
): Prices | FarePriceBreakdown => {
  const paxPricing = passengerPricing.pricing;
  const totalPricing = passengerPricing.pricing.total;

  if (totalPricing.fiat.value > 0) {
    return totalPricing;
  }

  // If total pricing is 0, it is a fixed price fare made up of taxes and fees and base amount (in points)
  return {
    taxesAndFees: paxPricing.taxAmount,
    baseAmount: paxPricing.baseAmount,
    taxLineItems: paxPricing.taxLineItems,
  };
};
